module.exports = __webpack_public_path__ + "static/media/tk-logo_3x.61309bdf.png";